import { fetchEndpointData } from '@utils/fetchEndpointData';

import type { OurContactInformationResponse } from './endpoints/OurContactInformationEndpoint.types';

export type OurContactInformation = OurContactInformationResponse;

export async function fetchOurContactInformation(): Promise<OurContactInformation> {
  return fetchEndpointData<OurContactInformationResponse>('/api/customer-portal/our-contact-information', {
    method: 'GET',
  });
}
